import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'general/js/store';
import BaseComponent from 'foundation/base-component';
import CourseLayout from './course-layout';

class CourseComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        ReactDOM.render(
            <Provider store={store}>
                <CourseLayout />
            </Provider>,
            this.element
        );
    }
}

export default CourseComponent;
